import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { View } from 'react-native';

import { createContainer } from '@dbk-legacy/muster/react';

import { Large } from '../../../components/common/text';
import ScrollableLayout from '../../../components/common/scrollable-layout';
import { LoadingCircle } from '../../../components/common/loading';

import { Checkbox } from '@dbk/ui-forms';
import Text,{H1} from '@dbk/ui-text';
import { List, ListItem } from '@dbk/ui-list';
import Button from '@dbk/ui-buttons';
import Modal from '@dbk/ui-modal';
import Spinner from '@dbk/ui-spinner';
import styles from './consolidation-setup.styles';
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';
import labelForPFid from '../../../utils/portfolio-number-aria-label';
class ConsolidationSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStep2: false,
      showStep3: false,
      isChecked: false,
      checkeCount: 0,
      count: 0,
      selectedStates: [],
      warningMsg: false,
      singlePortfolio: false
    };
    this.props.getConsolidationData();
    this.gotStepOne = this.gotStepOne.bind(this);
    this.goToStepTwo = this.goToStepTwo.bind(this);
    this.goToStepThree = this.goToStepThree.bind(this);
    this.callBackFunction = this.callBackFunction.bind(this);
    this.navigateToPortFollio = this.navigateToPortFollio.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.prepareDataList = this.prepareDataList.bind(this);
    this.deselectAll = this.deselectAll.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.renderTabletBlock = this.renderTabletBlock.bind(this);

  }

  componentDidMount() {
    const {
      deviceInfo
    } = this.props;
  }

  componentDidUpdate(prevProp, prevState) {
    if (this.props.consolidatesetup.consolidationData != prevProp.consolidatesetup.consolidationData) {

      if (this.props.consolidatesetup.consolidationData != null && this.props.consolidatesetup.consolidationData.length != 0) {
        this.prepareDataList();
      } else {
        this.setState({warningMsg: true});
      }
    }
    if(document.querySelector('.modal__header-container')){
      document.querySelector('.modal__header-container').focus();
    }
  }

  hideModal = () => {
    this.gotStepOne();
  }

  goToStepTwo() {
    const {checkeCount} = this.state;
    if (checkeCount === 1) {
      this.setState({
        singlePortfolio: true
      });
    }
    else {
      this.setState({
        showStep2: true,
        singlePortfolio: false
      });
    }
  }

  goToStepThree() {
    this.setState({
      showStep2: false,
      showStep3: true,
      singlePortfolio: false,
    })
  }

  gotStepOne() {
    this.setState({
      showStep2: false,
      showStep3: false,
      singlePortfolio: false,
    });
  }

  /*
    function for Deselecting all checkboxes
  */
  deselectAll() {
    let getList = this.state.selectedStates;
    let selectedRowCount = 0;
    getList.forEach(function (item, k) {
      item.isChecked = false;
    });

    this.setState({selectedStates: getList, checkeCount: selectedRowCount});
  }

  /*
    function for selecting all checkboxes
  */
  selectAll() {
    let getList = this.state.selectedStates;
    getList.forEach(function (item, k) {
      item.isChecked = true;
    });

    this.setState({selectedStates: getList, checkeCount: this.state.count});
  }

  /*
    function for preparing resultant JSON from muster data
    consist UI checkbox row shown to user
    flag isChecked :boolean value
  */

  prepareDataList() {
    let data = this.props.consolidatesetup.consolidationData;
    let preparedData = [], checkListItem = [];
    let listItemCount, selectedRowCount = 0;

    data.forEach(function (dataRow, i) {
      if (dataRow.relId == null) {
        checkListItem.push(dataRow);
      }
    });

    checkListItem.forEach(function (listRow, j) {
      listRow.isChecked = false;
    });

    checkListItem.forEach(function (listRow, j) {
      data.forEach(function (dataRow, k) {
        if ((dataRow.pfId == listRow.pfId) && dataRow.relId != null) {
          listRow.isChecked = true;
          return false;
        }
      });
    });
    checkListItem.forEach(function (listRow, j) {
      if (listRow.isChecked == true) {
        selectedRowCount = selectedRowCount + 1;
      }
    });
    listItemCount = checkListItem.length;
    this.setState({selectedStates: checkListItem, count: listItemCount, checkeCount: selectedRowCount});
  }

  callBackFunction() {
    this.props.changePage({pathname: '/profile'}, false);
  }

  navigateToPortFollio() {
    const {
      settings: { currentEnvironment: { remoteUrl } },
      auth: { userId, authHeader },
      i18n: { messages }
    } = this.props;
    this.props.consolidatesetup.setBtnLoader(true);
    let selectedList = this.state.selectedStates, jsonData = this.props.consolidatesetup.consolidationData;
    let requestBody = {}, sendPfId = [], sendBranchCode = [], sendRelId = null;
    selectedList.forEach(function (key, i) {
      if (key.isChecked) {
        sendBranchCode.push(key.branchCode);  // Prepare JSON to send
        sendPfId.push(key.pfId);
      }
    });

    jsonData.forEach(function (key, i) {
      if (key.relId != null) {
        sendRelId = key.relId;        // Get RelId from original data
        return false;
      }
    });
    requestBody.branchCode = sendBranchCode;
    requestBody.pfId = sendPfId;
    requestBody.relId = sendRelId;
    const CONSOLIDATED_SETUP_URL = remoteUrl + '/portfoliooverview/' + this.props.app.config.apiverion + '/save-user-rel-portfolio-selection';
    const body = { "userId": userId, "branchCode": sendBranchCode, "pfId": sendPfId, "relId": sendRelId }
    const x = new XMLHttpRequest();
    const that = this;
    x.open('POST', CONSOLIDATED_SETUP_URL, true);
    x.setRequestHeader('Authorization-Token', authHeader);
    x.setRequestHeader('content-type', 'application/json');
    x.responseType = 'text';
    x.timeout = 300000;

    x.ontimeout = function () { alert(messages['app.chedelivery.reports.systemErrorMessage']); }  // todo
    x.onload = function (e) {

      if (x.status === 200) {
        that.props.consolidatesetup.setResult(true);
        that.props.sendConsolidationData();
      } else {
        that.hideModal()
        that.props.consolidatesetup.setBtnLoader(false);
        alert(messages['app.chedelivery.reports.systemErrorMessage']);
      }
    }

    x.send(JSON.stringify(body));
    x.onerror = function (e) {
      that.hideModal();
      that.props.consolidatesetup.setBtnLoader(false);
      alert(messages['app.chedelivery.reports.systemErrorMessage']);
    };
  }

  handleChange(e, asset) {
    const { i18n: { messages }} = this.props;
    if(isEnterorSpaceKeyPressed(e)){
    let arrayList = this.state.selectedStates;
    let checkedCountTemp = 0;
    arrayList.forEach(function (dataRow, i) {
      if (dataRow.pfId == asset.pfId) {
        dataRow.isChecked = !asset.isChecked;
      }
    });
    arrayList.forEach(function (dataRow, i) {

      if (dataRow.isChecked == true) {
        checkedCountTemp = checkedCountTemp + 1;
      }
    });
    this.setState({
      selectedStates: arrayList, checkeCount: checkedCountTemp
    });
    }
  }

  renderListItems = () => {
    const assets = this.state.selectedStates;
    const { i18n: { messages }, auth} = this.props;

    return assets.map((item, index) => {
      let label = `${item.pfId} - ${item.refCcy.toUpperCase()} (${item.pfType} ${messages["app.dashboard.summaryData.portfolioId.label"]})`;
      return (
        <ListItem tabIndex={-1}
        role="none"
        onKeyDown={(e) => auth.settingsDisabled? null :this.handleChange(e,item)}
        onClick={(e) => auth.settingsDisabled? null :this.handleChange(e,item)} 
        className="profile__list-item" id="list_consolidationSetup_manageConsolidation_test"
         testID="list_manageConsolidation_consolidationSetup_test"> 
          <span tabIndex={0} className="profile__list-item-value">
            <Text size="large" className="profile__list-item-value" aria-label={labelForPFid(item.pfId.toString())+" "+item.refCcy+" "+item.pfType+" "+messages["app.dashboard.summaryData.portfolioId.label"]}>{label} </Text>
          </span>
          <Checkbox
            title={labelForPFid(item.pfId.toString())+" "+item.refCcy+" "+item.pfType+" "+messages["app.dashboard.summaryData.portfolioId.label"]}
            checked={item.isChecked}
            name={`consolidated_portfoilo ${index}`}
            disabled={auth.settingsDisabled}
          />
        </ListItem>
      );
    });
  }

  renderTabletBlock = () => {
    const assets = this.state.selectedStates;

    if (assets === undefined || assets === null) {
      return (<div />);
    }

    return(
      <div className="consolidation__items-wrapper">
        <List size="large" className="profile__list" fullWidth id="list_manageConsolidation_portfolios_consolidationSetup_test">
        {
          this.renderListItems()
        }
        </List>
      </div>
    );
  }

  handleOnSelectAll = () => {
    const { checkeCount } = this.state;
    if(checkeCount > 0) {
      this.deselectAll()
      return true;
    }
    this.selectAll();
    return true;
  }

  renderConsolidationSelectAll = () => {
    const { i18n: { messages }, auth } = this.props;
    const { checkeCount, count } = this.state;
    const indeterminate = checkeCount > 0 && checkeCount < count;
    const checked = checkeCount === count;

    return(
      <div className="consolidation__selected-number">
        <Text className="consolidation__current-selected" tabIndex={0}>
        {checkeCount} {messages['app.profile.consolidated.of']} {count} {messages['app.profile.consolidated.selected']}
        </Text>
        <div>
          <span tabIndex={0} id="text_manageConsolidation_consolidationSetup_test" onClick={this.handleOnSelectAll} className="consolidation__select-all">
            {
              checkeCount > 0 ? messages['app.profile.consolidatesetup.deselect'] :
              messages['app.profile.consolidatesetup.selectAll']
            }
          </span>
          <Checkbox id="checkbox_manageConsolidation_selectAll_consolidationSetup_test"
            title={ checkeCount > 0 ? messages['app.profile.consolidatesetup.deselect'] : messages['app.profile.consolidatesetup.selectAll']}
            checked={checked}
            indeterminate={indeterminate}
            onChange={this.handleOnSelectAll}
            disabled={auth.settingsDisabled}
          />
        </div>
      </div>
    );
  }

  modalContent = () => {
    const {
      showStep2, showStep3
    } = this.state;

    const { i18n: { messages }, screen } = this.props;
    const backLinkCss = classNames('custom-back-link', {'custom-back-link-mobile': screen.isSmall});
    const continueBtnCss = classNames('continue-button', {'continue-button-mobile': screen.isSmall});

    if (showStep2 === true) {
      return (
        <Modal
          testID="modal_manageConsolidation_consolidationSetup_test"
          isActive={showStep2}
          onClose={this.hideModal}
          header={<Text size="large">{messages['app.profile.consolidated.almostThere']}</Text>}
          content={
            <div className="consolidation-modal padding-20" >
              <span tabIndex={0}>{messages['app.profile.consolidatesetup.info']}</span>
              <div className="consolidation-modal__action">
                <div className="consolidation-modal__button-width consolidation-modal__button-back">
                  <div className='profile-modal__ghostly-btn'>
                    <Button fullWidth tertiary
                      size="large"
                      onPress={this.gotStepOne}>
                      {messages['app.common.backBtn']}
                    </Button>
                  </div>
                </div>
                <div className="consolidation-modal__button-width">
                  <Button fullWidth size="large" onPress={this.goToStepThree} testID="btn_manageConsolidation_continueModal_consolidationSetup_test">
                    {messages['app.profile.consolidatesetup.cont']}
                  </Button>
                </div>
              </div>
            </div>
          }
        />
      );
    }

    if (showStep3 === true) {
      return (
        <Modal
          testID="modal_manageConsolidation_wellDone_consolidationSetup_test"
          isActive={showStep3}
          onClose={this.hideModal}
          header={<Text size="large">{messages['app.profile.consolidated.welldone']}</Text>}
          content={
            <div className="consolidation-modal padding-20">
              <div tabIndex={0}>
                {messages['app.profile.consolidateSuccess']}
                {' '}
                {this.state.checkeCount}
                {' '}
                {messages['app.profile.consolidatedYr']}
                {' '}
                {this.state.count}
                {' '}
                {messages['app.profile.consolidatedPortView']}
                <br />
                <br />
                {messages['app.profile.consolidateMinute']}
                <br />
                <br />
                {messages['app.profile.consolidateMenu']}
              </div>
              <div className="consolidation-modal__action">
                <div className="consolidation-modal__button-width consolidation-modal__button-back">
                  <div className='profile-modal__ghostly-btn'>
                    <Button fullWidth tertiary
                      size="large"
                      onPress={this.goToStepTwo} >
                      {messages['app.common.backBtn']}
                    </Button>
                  </div>
                </div>
                <div className="consolidation-modal__button-width">
                  <Button fullWidth
                    size="large"
                    loading={this.props.consolidatesetup.btnLoading}
                    testID="btn_manageConsolidation_wellDoneContinue_consolidationSetup_test"
                    onPress={this.navigateToPortFollio} >
                    {messages['app.profile.consolidatesetup.cont']}
                  </Button>
                </div>
              </div>
            </div>
          }
        />
      );
    }
  }

  render() {
    const {i18n: {messages}, consolidatesetup, auth } = this.props;
    let messageText = '';

    const {
      showStep2, showStep3, warningMsg, singlePortfolio, checkeCount
    } = this.state;

    if (warningMsg || ((consolidatesetup.consolidationData == null) && (consolidatesetup.consolidationData != undefined))) {
      return (
        <div className="scene" tabIndex={0}>
          <View style={styles.warningMsg}>
            <Large style={styles.msgText}>{messages['app.profile.consolidatesetup.dataRes']}</Large>
          </View>
        </div>
      );
    }

    if (consolidatesetup.result === null || consolidatesetup.result === false) {
      return (
        <div className="scene" tabIndex={0}>
          <View style={styles.warningMsg}>
            <Large><Text style={styles.msgText}>{messages['app.profile.consolidatesetup.ServiceRes']}</Text></Large>
          </View>
        </div>
      );
    }
    
    messageText = singlePortfolio ? messages['app.profile.consolidatesetup.singlePortfolio'] : ' ';
    return (
      <div>
        <ScrollableLayout
        testID="Profile-view"
        body={
          <div className="row consolidation">
            <div className="columns small-12 large-12  profile-container">
              <div className="profile-container__title">
                <H1 tabIndex={0} id="title_manageConsolidation_consolidationSetup_test" className="margin-top-1">{messages['app.common.pageTitle.manageConsolidatedView']}</H1>
                <Text size="big" tabIndex={0} className="consolidation__subtitle">{messages['app.profile.consolidatesetup.subTitle']}</Text>
                <Text size="large" tabIndex={messageText !== " " ? 0 : -1}>{messageText}</Text>
              </div>
              { consolidatesetup.loading ?
                <div className="center-content">
                  <Spinner />
                </div>
                :
                <div className="profile__content">
                {
                  this.renderConsolidationSelectAll()
                }
                {
                  this.renderTabletBlock()
                }
                <div className="consolidation__action-container">
                  <div className="consolidation__button-width consolidation__button-skip--margin">
                    <Button
                      testID="btn_manageConsolidation_skip_consolidationSetup_test"
                      fullWidth
                      tertiary
                      size="large"
                      onPress={this.callBackFunction}
                      disabled={auth.settingsDisabled}
                    >
                      {messages['app.profile.consolidatesetup.skip']}
                    </Button>
                  </div>
                  <div className="consolidation__button-width">
                    <Button testID="btn_manageConsolidation_continue_consolidationSetup_test"
                      fullWidth
                      size="large"
                      onPress={this.goToStepTwo}
                      disabled={auth.settingsDisabled || checkeCount < 1}
                    >
                      {messages['app.profile.consolidatesetup.cont']}
                    </Button>
                  </div>
                </div>
              </div>}
            </div>
          </div>
        }
        />
        {this.modalContent()}
      </div>
    );
  }
}

export default createContainer({
  $renderError: () => <Error/>,
  $renderLoading: () => <LoadingCircle isPage={true}/>,
  $queries: {
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      },
        config: {
            apiverion: true
        },
    },
    settings: {
      currentEnvironment: {
          remoteUrl: true,
      },
    },
    auth: {
      userId: true,
      authHeader: true,
      settingsDisabled: true
    },
    getConsolidationData: {
      $call: 'consolidatesetup.getData'
    },
    sendConsolidationData: {
      $call: 'consolidatesetup.setData'
    },
    consolidatesetup: {
      consolidationData: true,
      result: true,
      loading: true,
      setResult: { $set: 'result'},
      btnLoading: true,
      setBtnLoader: { $set: 'btnLoading'},
    },
    changePage: {$call: 'ui.history.push'},
    i18n: {
      messages: true,
    },
    screen: {
      width: true,
      height: true,
      isSmall: true
    },
  },
}, ({...queries}) => ({
  ...queries,
}))(ConsolidationSetup);






